export const TOGGLE_LEFT_NAV_OPEN = 'TOGGLE_LEFT_NAV_OPEN';
export const TOGGLE_RIGHT_NAV_OPEN = 'TOGGLE_RIGHT_NAV_OPEN';
//# sourceMappingURL=actionTypes.js.map